import React from 'react';
import PropTypes from 'prop-types';

import HorizontalNavigation from './HorizontalNavigation';
import VerticalNavigation from './VerticalNavigation';

export const NAVIGATOR_TYPES = {
  VERTICAL: 'VERTICAL',
  HORIZONTAL: 'HORIZONTAL',
};

const Navigation = ({ type, ...props }) => {
  switch (type) {
    case NAVIGATOR_TYPES.HORIZONTAL:
      return <HorizontalNavigation {...props} />;
    case NAVIGATOR_TYPES.VERTICAL:
      return <VerticalNavigation {...props} />;
    default:
      // Due to PropType validation, default case is unreachable
      break;
  }
};

Navigation.propTypes = {
  type: PropTypes.oneOf(Object.values(NAVIGATOR_TYPES)).isRequired,
};

export default Navigation;
